import React, {useContext, useEffect, useRef, useState} from 'react'
import CloseButton from '../../Buttons/CloseButton/CloseButton'
import CircleInput from '../../Inputs/CircleInput/CircleInput'
import MainSelect from '../../Selects/MainSelect/MainSelect'
import DateRangePicker from '../../Inputs/DateRangePicker/DateRangePicker'
import PropTypes from 'prop-types'
import Attention from '../../Attention'
import ReactLoading from 'react-loading'
import useOutsideClick from '../../../hooks/useOutsideClick'
import Button from '../../Button'
import MultiSelect from "../../MultiSelect";
import {AuthContext} from "../../../context/AuthContext";
import {getOptions} from "../../../api/getMultiSelectOptions";
import icons from "../../../assets/icons";

function FilterSidebarTemplate(props) {
    const {token} = useContext(AuthContext)
    const [multiSelectOptions, setMultiSelectOptions] = useState({city: [], specialization: []})

    const onEnterPress = (event) => {
        if (event.key === 'Enter') {
            props.urlGenerator()
        }
    }
    const cityOptions = async () => await getOptions('city', token.token)
    const specializationOptions = async () => await getOptions('specialization', token.token)


    useEffect(() => {
        props.filterFieldsConf?.city && cityOptions().then(res => setMultiSelectOptions(prev => ({...prev, city: res})))
        props.filterFieldsConf?.specialization && specializationOptions().then(res => setMultiSelectOptions(prev => ({
            ...prev,
            specialization: res
        })))
    }, [])

    return (

        <div style={props.style} className='scale-up-hor-left page__filter-sidebar'>
            {
                props.filterComponent
                    ? props.filterComponent
                    :
                        <>
                            <CloseButton onClick={_ => props.showFilter()}/>
                            <div className='sidebar__top-btn-area' style={{marginBottom: '40px'}}>

                                {props.addOrg.org
                                    ? <button onClick={props.addOrg.onClick} className='addOrgBtn addOrgBtn_org'>Добавить
                                        организацию</button>
                                    : ''}
                                {props.addOrg.med ?
                                    <button onClick={props.addOrg.onClick} className='addOrgBtn addOrgBtn_medCenter '> Добавить
                                        мед. центр</button> : ''}
                                {props.addOrg.patient ?
                                    <button onClick={props.addOrg.onClick} className='addOrgBtn addOrgBtn_patient '> Добавить
                                        исследование</button> : ''}
                                {props.addOrg.custom ? <button onClick={props.addOrg.custom.onClick}
                                                               className='addOrgBtn addOrgBtn_patient '>{props.addOrg.custom.text}</button> : ''}
                                <div style={{display: 'flex'}}>
                                    {props.exportTemplateButtons.export
                                        ? <ExportButton onClick={props.exportTemplateButtons.onExport} title={'Экспорт'}/>
                                        : ''
                                    }
                                    <span style={{width: '10px', height: '1px'}}/>
                                    {props.exportTemplateButtons.registry
                                        ? <ExportButton onClick={props.exportTemplateButtons.onRegistry} title={'Реестр'}/>
                                        : ''
                                    }
                                </div>
								{props.exportTemplateButtons.printall
									? <div style={{display: 'flex', paddingTop:5}}>
										<ExportButton onClick={props.exportTemplateButtons.onPrint} title={'Печать'}/>
									   </div>
									: ''
								}
								{props.exportTemplateButtons.create
									? <div style={{display: 'flex', paddingTop:5}}>
										<Button size={'medium'} text={props.exportTemplateButtons.create} 
											onClick={props.exportTemplateButtons.onCreate}>{props.exportTemplateButtons.create}</Button>
									   </div>
									: ''
								}
                            </div>

                            <div className='page__filter-sidebar__title'>
                                Фильтровать
                            </div>
                            <div className='wrapper'>


                                {props.filterFieldsConf.fio ? <div className='field-area__option'>
                                    <CircleInput onKeyPress={onEnterPress} value={props.filterData} name={'fio'}
                                                 onChange={props.handleChange}
                                                 placeHolder={'ФИО'}/>
                                </div> : ''}

                                {props.filterFieldsConf.name ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress} value={props.filterData}
                                                     onChange={props.handleChange} name={'name'}
                                                     placeHolder={'Название'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.medBook ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress} value={props.filterData}
                                                     onChange={props.handleChange} name={'medBook'}
                                                     placeHolder={'№ Мед. Книжки'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.resultStudyType ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress} value={props.filterData}
                                                     onChange={props.handleChange} name={'resultStudyType'}
                                                     placeHolder={'Обследование'}/>
                                    </div>
                                    : ''}


                                {props.filterFieldsConf.org ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress}
                                                     value={props.filterData}
                                                     onChange={props.handleChange}
                                                     name={'organization'}
                                                     placeHolder={'Организация'}/>
                                    </div>
                                    : ''}

                                {props.filterFieldsConf.center ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress} value={props.filterData}
                                                     onChange={props.handleChange}
                                                     name={'medCenter'}
                                                     placeHolder={'Мед. центр'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.verCenter ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress}
                                                     value={props.filterData}
                                                     onChange={props.handleChange}
                                                     name={'verCenter'}
                                                     placeHolder={'Удостов. центр'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.verificationCenterName ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress}
                                                     value={props.filterData}
                                                     onChange={props.handleChange}
                                                     name={'name'}
                                                     placeHolder={'Удостов. центр'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.doctor ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress}
                                                     value={props.filterData}
                                                     onChange={props.handleChange}
                                                     name={'doctor'}
                                                     placeHolder={'Доктор'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.inn ?
                                    <div className='field-area__option'>
                                        <CircleInput onKeyPress={onEnterPress} value={props.filterData}
                                                     onChange={props.handleChange} name={'inn'}
                                                     placeHolder={'ИНН'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.period ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress} value={props.period} placeholder={'Период'}
                                                    onChange={props.selectPeriod}
                                                    type={'period'}/>
                                    </div>
                                    : ''}


                                {props.filterFieldsConf.date ? <div className='field-area__option'>
                                        <DateRangePicker
                                            onKeyPress={onEnterPress}
                                            onChange={e => {
                                                props.selectPeriod(null)
                                                props.setDate(e)
                                            }}
                                            value={props.date}
                                        />
                                    </div>
                                    : ''}

                                {props.filterFieldsConf.result ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress} value={props.result} placeholder={'Результат'}
                                                    onChange={props.selectResult}
                                                    type={'result'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf?.status ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress}
                                                    value={props.status}
                                                    placeholder={'Статус'}
                                                    onChange={props.selectStatus}
                                                    type={'status'}/>
                                    </div>
                                    : ''}


                                {props.filterFieldsConf?.status1 ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress}
                                                    value={props.status}
                                                    placeholder={'Статус'}
                                                    onChange={props.selectStatus}
                                                    type={'status1'}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf?.doctorStatus ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress}
                                                    value={props.status}
                                                    placeholder={'Статус'}
                                                    onChange={props.selectStatus}
                                                    type={'doctorStatus'}/>
                                    </div>
                                    : ''}


                                {props.filterFieldsConf.base ? <div className='field-area__option'>

                                        <MainSelect onKeyPress={onEnterPress} value={props.base} placeholder={'Вид исследования'}
                                                    onChange={props.selectPlace}
                                                    type={'base'}/>

                                    </div>
                                    : ''}


                                {props.filterFieldsConf.city ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress}
                                                    placeholder={'Город'}
                                                    value={props.select.city}
                                                    onChange={selected => props.selectHandler('city', selected)}
                                                    options={multiSelectOptions['city']}/>
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.testType ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress}
                                                    placeholder={'Вид тестирования'}
                                                    value={props.select.type}
                                                    onChange={selected => props.selectHandler('type', selected)}
                                                    type={'testType'}
                                        />
                                    </div>
                                    : ''}

                                {props.filterFieldsConf.testStatus ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress}
                                                    placeholder={'Статус тестирования'}
                                                    value={props.status}
                                                    onChange={props.selectStatus}
                                                    type={'testStatus'}
                                        />
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.success ?
                                    <div className='field-area__option'>
                                        <MainSelect onKeyPress={onEnterPress}
                                                    placeholder={'Статус'}
                                                    value={props.select.checked}
                                                    onChange={selected => props.selectHandler('checked', selected)}
                                                    type={'success'}
                                        />
                                    </div>
                                    : ''}
                                {props.filterFieldsConf.specialization ?
                                    <div className='field-area__option'>
                                        <MultiSelect onKeyPress={onEnterPress}
                                                     placeholder={'Специализация'}
                                                     value={props.multiSelect['specialization']}
                                                     onChange={selected => props.multiSelectHandler('specialization', selected)}
                                                     options={multiSelectOptions['specialization']}
                                                     downIcon={<img width={'15px'} height={'15px'} src={icons.arrowDown} alt='drop'/>}

                                        />
                                    </div>
                                    : ''}

                                <div className={'wrapper'}>

                                    <div className='button-area'>
                                        {props.filterBarButtons.downloadTemplate.show
                                            ? <a className={'downloadTemplate'} type={'download'}
                                                 href={'https://ams-unity-group.ru/shablon.xlsx'}>

                                                <button>Скачать шаблон</button>
                                            </a>
                                            : ''}

                                        <div className={'confirm_area'}>
                                            <button className={'button'} onKeyPress={onEnterPress}
                                                    onClick={props.urlGenerator}>Применить
                                            </button>
                                            <button title={'Очистить'} className={'button cleanButton_mobile'} onClick={props.clean}>
                                                Очистить
                                            </button>
                                            <span style={{width: '10px', height: '1px'}}/>

                                            <button
                                                title={'Очистить'}
                                                className={'button cleanButton'}
                                                onClick={props.clean}
                                                style={{
                                                    background: 'white',
                                                    color: 'black',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    borderRadius: '100%',
                                                    width: '50px',
                                                    height: '50px'
                                                }}>
                                                <i
                                                    style={{color: 'black', fontSize: '19px', marginTop: '1px', marginLeft: '0'}}
                                                    className='fas fa-times'/>

                                            </button>


                                        </div>


                                    </div>
                                </div>
                            </div>
                        </>

            }

        </div>
    )
}

function ExportButton(props) {
    const [attentionVisibility, setAttentionVisibility] = useState(false)
    const [reqResponse, setReqResponse] = useState({})
    const myRef = useRef()

    useOutsideClick(myRef, () => {
        if (attentionVisibility)
            setAttentionVisibility(false)
        setReqResponse({})
    })

    const clickHandler = async () => {
        setAttentionVisibility(true)
        setReqResponse(await props.onClick().catch(e => {
            return {status: 400}
        }))
    }

    const attentionInner = res => {
        if (res.status === 200) {
            if (res?.body?.message === 'ok') {
                return <>
                    Мы отправили данные на почту <span
                    style={{color: 'rgb(128, 189, 255)'}}>{res.body?.data?.email}</span>
                </>
            } else if (res?.body?.message === 'empty') {
                return <>
                    Нет данных
                </>
            } else if (res?.body?.message) {
                return <>
                    {res?.body?.message}
                </>
            } else {
                return <>
                    Ой! Что-то пошло не так. Возможно, это временная неполадка. Пожалуйста, повторите попытку позже.
                </>
            }
        } else {
            return <>
                {res?.message ? res?.message : 'Ой! Что-то пошло не так. Возможно, это временная неполадка. Пожалуйста, повторите попытку позже.'}
            </>
        }


    }


    return (
        <div className={'dontShowInMobile'} style={{position: 'relative'}}>
            <Button size={'medium'} text={props.title} onClick={clickHandler}>{props.title}</Button>
            {attentionVisibility ? <Attention
                    reff={myRef}
                    closeHandler={_ => {
                        setAttentionVisibility(false)
                        setReqResponse({})
                    }}
                    attentionText={
                        <>
                            {reqResponse?.status ? attentionInner(reqResponse) :
                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                    <ReactLoading type={'spin'}
                                                  color='rgb(128, 189, 255)'
                                                  height={50}
                                                  width={50}/>
                                </div>}
                        </>
                    }/>
                : ''}
        </div>
    )
}

export default FilterSidebarTemplate
FilterSidebarTemplate.defaultProps =
    {
        filterFieldsConf: PropTypes.shape({
            fio: false,
            date: false,
            period: false,
            org: false,
            place: false,
            medBook: false,
            center: false,
            result: false
        })
    }
